import React from 'react';
export function HeroIllustration() {
  return <div className="relative w-full aspect-square max-w-[600px] mx-auto" data-id="element-163">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-indigo-500/10 blur-[80px] rounded-full" data-id="element-164" />

      {/* Floating Integration Logos */}
      <div className="absolute top-[10%] left-[15%] animate-float delay-100 bg-slate-900/80 backdrop-blur-sm border border-slate-700 rounded-xl p-3 shadow-xl" data-id="element-165">
        <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center text-[10px] font-bold text-white" data-id="element-166">
          Jira
        </div>
      </div>
      <div className="absolute top-[20%] right-[10%] animate-float delay-500 bg-slate-900/80 backdrop-blur-sm border border-slate-700 rounded-xl p-3 shadow-xl" data-id="element-167">
        <div className="w-6 h-6 bg-purple-500 rounded flex items-center justify-center text-[10px] font-bold text-white" data-id="element-168">
          Slack
        </div>
      </div>
      <div className="absolute bottom-[25%] left-[5%] animate-float delay-300 bg-slate-900/80 backdrop-blur-sm border border-slate-700 rounded-xl p-3 shadow-xl" data-id="element-169">
        <div className="w-6 h-6 bg-blue-400 rounded flex items-center justify-center text-[10px] font-bold text-white" data-id="element-170">
          Conf
        </div>
      </div>
      <div className="absolute bottom-[15%] right-[20%] animate-float delay-700 bg-slate-900/80 backdrop-blur-sm border border-slate-700 rounded-xl p-3 shadow-xl" data-id="element-171">
        <div className="w-6 h-6 bg-slate-200 rounded flex items-center justify-center text-[10px] font-bold text-slate-900" data-id="element-172">
          N
        </div>
      </div>
      <div className="absolute top-[45%] right-[5%] animate-float delay-1000 bg-slate-900/80 backdrop-blur-sm border border-slate-700 rounded-xl p-3 shadow-xl" data-id="element-173">
        <div className="w-6 h-6 bg-slate-800 rounded flex items-center justify-center text-[10px] font-bold text-white border border-slate-600" data-id="element-174">
          GH
        </div>
      </div>

      {/* Network Graph SVG */}
      <svg viewBox="0 0 400 400" className="w-full h-full relative z-10" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-175">
        <defs data-id="element-176">
          <linearGradient id="lineGrad1" x1="200" y1="200" x2="100" y2="100" gradientUnits="userSpaceOnUse" data-id="element-177">
            <stop stopColor="#6366F1" data-id="element-178" />
            <stop offset="1" stopColor="#38BDF8" stopOpacity="0.2" data-id="element-179" />
          </linearGradient>
          <linearGradient id="lineGrad2" x1="200" y1="200" x2="320" y2="150" gradientUnits="userSpaceOnUse" data-id="element-180">
            <stop stopColor="#6366F1" data-id="element-181" />
            <stop offset="1" stopColor="#C084FC" stopOpacity="0.2" data-id="element-182" />
          </linearGradient>
          <linearGradient id="lineGrad3" x1="200" y1="200" x2="150" y2="300" gradientUnits="userSpaceOnUse" data-id="element-183">
            <stop stopColor="#6366F1" data-id="element-184" />
            <stop offset="1" stopColor="#38BDF8" stopOpacity="0.2" data-id="element-185" />
          </linearGradient>
          <linearGradient id="lineGrad4" x1="200" y1="200" x2="280" y2="280" gradientUnits="userSpaceOnUse" data-id="element-186">
            <stop stopColor="#6366F1" data-id="element-187" />
            <stop offset="1" stopColor="#C084FC" stopOpacity="0.2" data-id="element-188" />
          </linearGradient>
        </defs>

        {/* Connections */}
        <path d="M200 200 L100 100" stroke="url(#lineGrad1)" strokeWidth="2" strokeDasharray="4 4" className="animate-pulse" data-id="element-189" />
        <path d="M200 200 L320 150" stroke="url(#lineGrad2)" strokeWidth="2" data-id="element-190" />
        <path d="M200 200 L150 300" stroke="url(#lineGrad3)" strokeWidth="2" strokeDasharray="4 4" data-id="element-191" />
        <path d="M200 200 L280 280" stroke="url(#lineGrad4)" strokeWidth="2" data-id="element-192" />

        <path d="M100 100 L150 60" stroke="#38BDF8" strokeOpacity="0.2" strokeWidth="1" data-id="element-193" />
        <path d="M320 150 L350 220" stroke="#C084FC" strokeOpacity="0.2" strokeWidth="1" data-id="element-194" />
        <path d="M150 300 L80 260" stroke="#38BDF8" strokeOpacity="0.2" strokeWidth="1" data-id="element-195" />
        <path d="M280 280 L220 340" stroke="#C084FC" strokeOpacity="0.2" strokeWidth="1" data-id="element-196" />

        {/* Nodes */}
        {/* Center Hub */}
        <circle cx="200" cy="200" r="12" fill="#6366F1" className="origin-[200px_200px] animate-pulse-node" data-id="element-197" />
        <circle cx="200" cy="200" r="24" stroke="#6366F1" strokeOpacity="0.3" strokeWidth="1" data-id="element-198" />

        {/* Primary Nodes */}
        <circle cx="100" cy="100" r="8" fill="#38BDF8" className="origin-[100px_100px] animate-pulse-node delay-300" data-id="element-199" />
        <circle cx="320" cy="150" r="8" fill="#C084FC" className="origin-[320px_150px] animate-pulse-node delay-700" data-id="element-200" />
        <circle cx="150" cy="300" r="8" fill="#38BDF8" className="origin-[150px_300px] animate-pulse-node delay-500" data-id="element-201" />
        <circle cx="280" cy="280" r="8" fill="#C084FC" className="origin-[280px_280px] animate-pulse-node delay-1000" data-id="element-202" />

        {/* Secondary Nodes */}
        <circle cx="150" cy="60" r="4" fill="#38BDF8" fillOpacity="0.5" data-id="element-203" />
        <circle cx="350" cy="220" r="4" fill="#C084FC" fillOpacity="0.5" data-id="element-204" />
        <circle cx="80" cy="260" r="4" fill="#38BDF8" fillOpacity="0.5" data-id="element-205" />
        <circle cx="220" cy="340" r="4" fill="#C084FC" fillOpacity="0.5" data-id="element-206" />
      </svg>
    </div>;
}